import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

interface UpdateFollowUpParams {
  followupMessage: string;
  followupDurationValue: number;
  followupDurationUnit: string;
}

interface UpdateFollowUpResponse {
  carePlan: fhirTypes.CarePlan;
  followupDurationUnit: string | null;
  followupDurationValue: number | null;
  followupMessage: string | null;
}

export const useUpdateFollowUp = ({
  childEncounterId,
  carePlanId,
}: {
  childEncounterId: string;
  carePlanId: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<UpdateFollowUpResponse, UpdateFollowUpParams>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.FollowUp.UPDATE({
          patientId,
          childEncounterId,
          carePlanId,
        }),
      mutationFn: (params) => {
        return axiosInstance.patch(
          `/charting/careplan/${carePlanId}/followup`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.FollowUp.DEFAULT({
              patientId,
              childEncounterId,
              carePlanId,
            }),
        });
      },
    },
  });
};
